import React from 'react';
import { node } from 'prop-types';
import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

const GlobalStyle = createGlobalStyle`
  ${reset};

  @font-face {
    font-family: 'Spoqa Han Sans';
    font-weight: 700;
    src: local('Spoqa Han Sans Bold'),
      url('//static.dabangapp.com/font/Spoqa Han Sans Bold.woff2') format('woff2'),
      url('//static.dabangapp.com/font/Spoqa Han Sans Bold.woff') format('woff'),
      url('//static.dabangapp.com/font/Spoqa Han Sans Bold.ttf') format('truetype');
  }
  @font-face {
    font-family: 'Spoqa Han Sans';
    font-weight: 400;
    src: local('Spoqa Han Sans Regular'),
      url('//static.dabangapp.com/font/Spoqa Han Sans Regular.woff2') format('woff2'),
      url('//static.dabangapp.com/font/Spoqa Han Sans Regular.woff') format('woff'),
      url('//static.dabangapp.com/font/Spoqa Han Sans Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: 'Spoqa Han Sans';
    font-weight: 300;
    src: local('Spoqa Han Sans Light'),
      url('//static.dabangapp.com/font/Spoqa Han Sans Light.woff2') format('woff2'),
      url('//static.dabangapp.com/font/Spoqa Han Sans Light.woff') format('woff'),
      url('//static.dabangapp.com/font/Spoqa Han Sans Light.ttf') format('truetype');
  }
  @font-face {
    font-family: 'LAB디지털';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_20-07@1.0/LAB디지털.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  html {
    height: 100%;
    font-family: 'Spoqa Han Sans', -apple-system, sans-serif, 'LAB디지털';
  }

  body {
    ${'' /* max-width: 640px;
    height: 100%;
    margin: 0 auto;
    font-family: 'Spoqa Han Sans', -apple-system, sans-serif;
    position: relative; */}
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    max-width: 640px;
    height: 100%;
    margin: 0 auto;
    padding: 0px;
    overscroll-behavior-y: contain;
  }

  a {
    color: inherit;
    text-decoration: none;
    cursor: pointer;
  }

  input, button {
    &:focus,
    &:active {
      outline: none;
    }
  }

  textarea,
  input {
    border-radius: 0;
    /* appearance: none; */

    &[type="number"]::-webkit-outer-spin-button,
    &[type="number"]::-webkit-inner-spin-button {
      appearance: none;
      margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }
    
    &::-ms-clear{
      display: none;
    }
    
    &::-webkit-input-placeholder {
      color: #8f8f8f;
    }
    &:-ms-input-placeholder {
      color: #8f8f8f;
    }
    &::placeholder {
      color: #8f8f8f;
    }
  }

  button {
    margin: 0;
    padding: 0;
    outline: none;
    border-radius: 0;
    background-color: #fff;
    cursor: pointer;

    /* 터치 하이라이트 제거 */
    outline: none;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;

    /* IE 버튼 스타일 때문에 사용 */
    > span {
      position: relative;
    }
  }

  input, textarea {
    user-select: text;
  }

  select, input, textarea {
    outline: none;
  }

  ${'' /* input[type="checkbox"] {
    margin: 0;
    padding: 0;
  } */}

  h1, h2, h3, h4, h5, h6, strong, b {
    font-weight: 700;
  }

  textarea {
    padding: 0;
  }

  #___gatsby {
    width: 100%;
    height: 100%;
    background-color: #fff;
    position: relative;

    > div {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      -webkit-box-pack: justify;
      justify-content: space-between;
      width: 100%;
      min-height: 100%;
      position: relative;
    }
  }
`;

const Layout = ({ children }) => {
  return (
    <>
      <GlobalStyle />
      {children}
    </>
  );
};

Layout.propTypes = {
  children: node.isRequired,
};

export default Layout;
